/*
 * Copyright 2026 NXGN Management, LLC. All Rights Reserved.
 */

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { InitiateApplicationComponent } from "./initiate-application/initiate-application.component";

@NgModule({
  declarations: [InitiateApplicationComponent],
  imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule]
})
export class OnboardingModule {}
